// apps/web/src/features/admin/form-config/fields/scrollFieldIntoView.ts
// R-71 (2026-05-14) — invoked from FormConfigPage when the operator
// clicks a publish error with linkTarget. Scrolls the FieldRow with
// matching data-field-name into view and applies a 1.8s transient
// .field-row--highlight class for visual confirmation.

const HIGHLIGHT_CLASS = 'field-row--highlight';
const HIGHLIGHT_DURATION_MS = 1800;

export function scrollFieldIntoView(fieldName: string): void {
  const pane = document.querySelector('[data-field-list-pane]');
  const el = pane?.querySelector(`[data-field-name="${CSS.escape(fieldName)}"]`);
  if (!el) return;
  el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  el.classList.add(HIGHLIGHT_CLASS);
  setTimeout(() => el.classList.remove(HIGHLIGHT_CLASS), HIGHLIGHT_DURATION_MS);
}
